import { IFilter } from "../components/global/Wines/WineFilters";
import { Wine } from "../context/wineContext/reducer";
import _ from "lodash";

export const formatScore = (score: string | null | undefined) => {
  if (score === null || score === undefined) return "";
  if (score === "?") return score;
  if(!score || score.includes("(")) return score.replace('.5', '+');
  let result = score.replace(/\?/g, "");

  if(score.includes("-")) {
    const split = result.split("-").map(x => parseInt(x));
    result = ((split[0] + split[1]) / 2).toString();
  }

  if(result.includes('.')) {
    result = result.split('.')[0] + "+";
  }

  return result;
}

export const SUBSCRIBERS_ONLY_HINT = "Subscribers only";

// Score sorting is ignored by the API for non-subscribers, so show the option as disabled for them.
export const lockScoreSortOptions = <T extends { value: string }>(options: T[], locked: boolean, scoreValue = "score") =>
  locked
    ? options.map((option) => option.value === scoreValue ? { ...option, disabled: true, hint: SUBSCRIBERS_ONLY_HINT } : option)
    : options;

export const nameProducerAndVintage = (wine: Wine): string => {
  const { wine_name, producer_name, vintage } = wine;

  if (wine_name && producer_name && vintage) {
    return `${producer_name} ${wine_name} ${vintage}`;
  } else if (wine_name && producer_name) {
    return `${producer_name} ${wine_name}`;
  } else {
    return wine_name;
  }
};

export const colorOptions = [
  "Red",
  "White",
  "Rosé",
  "Orange",
  "Sparkling White",
  "Sparkling Rosé",
  "Sparkling Red",
  "Sweet White",
  "Sweet Red",
  "Sweet Sparkling White",
  "Sweet Sparkling Rose",
  "Sweet Sparkling Red",
  "Fortified/Spirits"
]

export const wineOrigins = [
  "Argentina",
  "Australia",
  "Austria",
  "Canada",
  "Chile",
  "China",
  "Croatia",
  "England",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Israel",
  "Italy",
  "Japan",
  "Lebanon",
  "Morocco",
  "New Zealand",
  "Portugal",
  "Slovenia",
  "South Africa",
  "Spain",
  "Switzerland",
  "Turkey",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Wales"
];

export const formatFilterParams = (filterQuery: IFilter ) => {
  if (_.isEmpty(filterQuery)) return {};

  const f: IFilter = { ...filterQuery };
  return {
    "filters[color]": f.color,
    "filters[country]": f.country,
    "filters[price_range_min]": f.priceBetweenMin,
    "filters[price_range_max]": f.priceBetweenMax,
    "filters[review_date_range_min]": f.reviewDateMin,
    "filters[review_date_range_max]": f.reviewDateMax,
    "filters[created_at_from]": f.createdAtFrom,
    "filters[created_at_to]": f.createdAtTo,
    "filters[score_range_min]": f.scoreBetweenMin,
    "filters[score_range_max]": f.scoreBetweenMax,
    "filters[vintage_range_min]": f.vintageYearMin,
    "filters[vintage_range_max]": f.vintageYearMax,
    "filters[author]": f.author,
    "filters[searchable]": f.searchable,
  }
};

export const convertFilterParams = (filterQuery?: string) => {
  return filterQuery?.split('_').reduce((acc, curr) => {
    const [key, value] = curr.split('-');
    acc[key] = typeof value === 'string' ? value : Number(value);
    return acc;
  }, {}) as IFilter;
};

export const extractLabelAndYear = (text: string) => {
  if (!text) return { term: "", vintage: null };
  let words = text.split(" ");
  let vintage: string;
  for (const word of words) {
    let potentialYear = Number(word);
    if (!isNaN(potentialYear) && potentialYear >= 1900 && potentialYear <= new Date().getFullYear()) {
      vintage = word;
      break;
    }
  }
  if(vintage) {
    const formattedTerm = text.replace(vintage, '');
    return { term: formattedTerm.trim(), vintage };
  } else {
    return { term: text, vintage: null };
  }
}

export const yearRegex = new RegExp(/(?:\d{4}|\d{2})/g);
